import React, { useState, useEffect } from 'react';
import { LeaderboardHeader } from '../components/leaderboard/LeaderboardHeader';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import LeaderboardService from '../services/LeaderboardService';

export const LeaderboardPage = () => {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [playerRank, setPlayerRank] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        setLoading(true);
        const { leaderboard } = await LeaderboardService.getTop10();
        setLeaderboardData(leaderboard);

        // Try to get player rank if wallet is available
        const walletAddress = localStorage.getItem('walletAddress');
        if (walletAddress) {
          try {
            const rankData = await LeaderboardService.getPlayerRank(walletAddress);
            setPlayerRank(rankData);
          } catch (rankError) {
            console.error('Failed to fetch player rank:', rankError);
          }
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching leaderboard:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboardData();
  }, []);

  const playerInTop10 = playerRank?.rank && playerRank.rank <= 10;

  return (
    <div className="h-screen bg-bg flex flex-col overflow-hidden">
      <LeaderboardHeader />

      <main className="container mx-auto px-6 py-8 flex-1 overflow-y-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-heading mb-2">排行榜 Leaderboard</h1>
          <p className="text-text/70 font-base">Top players ranked by food points earned</p>
        </div>

        {loading && (
          <div className="text-center py-16">
            <p className="text-xl font-base text-text/70">Loading leaderboard...</p>
          </div>
        )}

        {error && (
          <div className="text-center py-16">
            <p className="text-xl font-base text-red-500">Failed to load leaderboard</p>
            <p className="text-sm text-text/50 mt-2">{error}</p>
          </div>
        )}

        {!loading && !error && (
          <>
            <div className="bg-white rounded-base shadow-light mb-8">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-16">Rank</TableHead>
                    <TableHead>Username</TableHead>
                    <TableHead>Pet Name</TableHead>
                    <TableHead>Wallet</TableHead>
                    <TableHead className="text-right">Points</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {leaderboardData.map((entry) => (
                    <TableRow
                      key={entry.rank}
                      className={playerRank?.rank === entry.rank ? 'bg-yellow-100' : ''}
                    >
                      <TableCell className="font-heading">#{entry.rank}</TableCell>
                      <TableCell className="font-base">{entry.username || 'Anonymous'}</TableCell>
                      <TableCell className="font-base">{entry.pet_name || 'N/A'}</TableCell>
                      <TableCell className="font-mono text-sm">{entry.wallet_address}</TableCell>
                      <TableCell className="text-right font-heading">{entry.food_points}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>

            {playerRank && !playerInTop10 && (
              <div className="bg-white rounded-base shadow-light border-2 border-yellow-400">
                <div className="p-4 border-b-2 border-border">
                  <h3 className="font-heading text-lg">Your Rank</h3>
                </div>
                <Table>
                  <TableBody>
                    <TableRow className="bg-yellow-50">
                      <TableCell className="font-heading w-16">#{playerRank.rank}</TableCell>
                      <TableCell className="font-base">{playerRank.username || 'Anonymous'}</TableCell>
                      <TableCell className="font-base">{playerRank.pet_name || 'N/A'}</TableCell>
                      <TableCell className="font-mono text-sm">{playerRank.wallet_address}</TableCell>
                      <TableCell className="text-right font-heading">{playerRank.food_points}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            )}
          </>
        )}

        <div className="mt-8 p-6 bg-white rounded-base border-2 border-border shadow-light">
          <h3 className="text-xl font-heading mb-2">关于食物点 (About Food Points)</h3>
          <p className="text-sm text-text/70">
            通过食用作物和鱼类可获得食物点数。精心照料你的宠物，攀登排行榜！空投奖励将定期发放，前十名玩家更可获得额外特别奖励！            <br/>
            
            Food points are earned by consuming crops and fish. Take good care of your pet and climb the leaderboard! Airdrops will be dispersed on a regular basis, and Top 10 will earn even more special rewards!          </p>
        </div>
      </main>
    </div>
  );
};

export default LeaderboardPage;
